import { createClient } from "@sanity/client";

const sanity = createClient({
	projectId: "nopvtuvd",
	dataset: "production",
	apiVersion: "2025-07-28",
	useCdn: false,
});

export { sanity };
